import settings from '@/settings/public'
import { encodePathSegment } from '@/utils/url/apiPath'

export function getImageUrl({
  id,
  cut,
  scale = '50',
}: {
  id?: string | undefined
  cut?: string
  scale?: string
}) {
  return !id ? null : `${settings.api.host}/api/images?id=${encodePathSegment(id)}&cut=${encodePathSegment(cut ?? '')}&scale=${encodePathSegment(scale ?? '')}`
}

export function useImage({
  id,
  images,
  cut = 'backdrop',
  scale = '50',
  index = 0,
}: {
  id?: string
  images?: any[]
  cut?: string
  scale?: string | number
  index?: number
}) {
  const appCode = settings.app.code
  // Use the provided id directly if available
  const imageId = id
    ? id
    : images
      ?.filter((image: any) => image.type === cut && (image?.appCode === appCode || !image?.appCode))
      ?.[index]?._id || images?.[0]?._id

  const url = getImageUrl({ id: imageId, cut, scale: scale.toString() })

  // Return a memoized version of getImageUrl that uses the preset cut and scale
  const getPresetImageUrl = (params: { id: string | undefined }) => {
    return getImageUrl({ ...params, cut, scale: scale.toString() })
  }

  return {
    url,
    getImageUrl: getPresetImageUrl,
  }
}